/**
 * Guía: Reportes Financieros.
 *
 * Contenido derivado del capítulo **30** del manual: §0 (lo que aquí se
 * produce sale de la plataforma) y §1 (los seis informes).
 *
 * Las dos consecuencias del §0 son los dos pasos centrales: una cifra
 * equivocada aquí sobrevive al error, y el documento tiene que decir de qué
 * está hablando —periodo, moneda y zona horaria— para ser verificable.
 */

import type { TourFlow } from '../types';

const REPORTES_PATH = '/finance-reports';

export const c30ReportesFinancieros: TourFlow = {
  id: 'admin.finance-reports',
  chapter: '30',
  title: 'Reportes financieros',
  summary:
    'Documentos que salen de la plataforma: qué revisar antes de generarlos y por qué no se corrigen después.',
  href: REPORTES_PATH,
  requiresCountry: true,
  estimatedMin: 3,
  steps: [
    {
      id: 'intro',
      title: 'Esto no se mira: se envía',
      body:
        'El resto del bloque enseña dinero en pantalla. Aquí se fabrica un documento que se ' +
        'descarga, se adjunta a un correo y se lee meses después sin nadie delante que lo ' +
        'explique.',
      route: REPORTES_PATH,
    },
    {
      id: 'no-fixing-later',
      title: 'Una cifra equivocada aquí sobrevive al error',
      body:
        'En pantalla se corrige y desaparece; en un informe ya enviado, no. Por eso el ' +
        'momento de revisar es antes de generar, no después.',
    },
    {
      id: 'range',
      title: 'El rango es lo primero que hay que mirar',
      body:
        'Los atajos cubren casi todos los casos, y el rango libre el resto. El periodo se ' +
        'recorta en la zona horaria del país, y el documento lo dice: sin eso, un informe ' +
        'no es verificable.',
      target: 'admin.financeReports.range',
      placement: 'bottom',
      optionalTarget: true,
    },
    {
      id: 'six-reports',
      title: 'Cada informe responde una pregunta distinta',
      body:
        'No son variantes del mismo documento. Antes de generar uno conviene saber a qué ' +
        'pregunta responde, porque enviar el que no era obliga a mandar una corrección.',
      target: 'admin.financeReports.cards',
      placement: 'top',
      optionalTarget: true,
    },
    {
      id: 'currency',
      title: 'La moneda va escrita dentro',
      body:
        'Un total sin moneda no significa nada en una plataforma con varios países. El ' +
        'documento la lleva; al reenviarlo, conviene repetirlo en el correo, porque quien ' +
        'lo recibe suele mirar sólo el número.',
    },
  ],
};
